import { Injectable } from '@angular/core';

import { ActivatedRouteSnapshot, Resolve } from '@angular/router';
import { QuoteService } from '@univacity/angular/datas';
import { Quote } from '@univacity/shared/types';
import { NzMessageService } from 'ng-zorro-antd/message';

import { catchError, Observable } from 'rxjs';

@Injectable({
  providedIn: 'root',
})
export class QuoteResolver implements Resolve<Observable<Quote>> {
  constructor(private svc: QuoteService, private message: NzMessageService) {}

  resolve(route: ActivatedRouteSnapshot): Observable<Quote> {
    const { reference, lastName } = route.queryParams;
    return this.svc.findOneByReference(reference, lastName).pipe(
      catchError((err) => {
        console.error(err);
        if (err.statusCode === 404)
          this.message.error($localize`Payment not found`);
        else this.message.error($localize`Something went wrong`);
        throw err;
      })
    );
  }
}
